const warehouseManagementType = {
	daVinci: 'da%20vinci',
	extensiv: 'extensiv',
	zethcon: 'zethcon',
};

export { warehouseManagementType };



// WEBPACK FOOTER //
// ./src/common/constants/warehouseManagementTypeConstants.js